import { render } from "./MerchantInquiryViewPage.vue?vue&type=template&id=68522e26"
import script from "./MerchantInquiryViewPage.vue?vue&type=script&lang=js"
export * from "./MerchantInquiryViewPage.vue?vue&type=script&lang=js"
script.render = render

export default script